module.exports = __webpack_public_path__ + "static/assets/cd7616ddcc603802ffc1958cd8cf1d33.png";